import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'ui/InputSelect'
import { Sort } from 'util/constants'

interface Props {
    entityType: string
    sort: Sort
    onSortChange: (newSort: Sort) => void
}

const EntitiesSort = ({ sort, onSortChange }: Props) => {

    const handleSortChange = (newSort: Sort) => {
        onSortChange(newSort)
    }

    return (
        <div className=''>
        <Select onValueChange={(value: Sort) => handleSortChange(value)}>
            <SelectTrigger className="px-3 py-2">
                <SelectValue placeholder="Sort" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="top">Top</SelectItem>
                <SelectItem value="new">New</SelectItem>
                <SelectItem value="bottom">Bottom</SelectItem>
                <SelectItem value="old">Old</SelectItem>
                </SelectContent>
            </Select>
        </div>
    )
}

export default EntitiesSort